import React from 'react';
import styled from 'styled-components/macro';
import {
  Container, Row, Col, Div,
} from '../../components/grid';
import { Image } from '../../components/Image';
import {
  Table, Td, Th, Tr,
} from '../../components/tables';
import {
  Heading1,
  Paragraph,
  Heading2,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { ScreenSizeDetector } from '../../lib/helpers';

const StyledParagraph = styled(Paragraph)`
  font-size: 16px;

  @media (max-width: 1199px) {
    font-size: inherit;
  }
`;
const StyledTable = styled(Table)`
  font-size: 16px;

  @media (max-width: 1199px) {
    font-size: inherit;
  }
`;

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="HoldbarhedFlasker">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1 textCenter>
            Holdbarhed på flasker og dåser
          </Heading1>
          <StyledParagraph bold>
            Opdateret juli 2022
          </StyledParagraph>
          <StyledParagraph>
            Holdbarhed på flasker og dåser afhænger af indholdet og forpakningen - der er også forskel på de enkelte mærker. På denne side giver vi eksempler på holdbarhed på diverse produkter.
          </StyledParagraph>
          <StyledParagraph>
            Nedenstående holdbarhed er fra de bliver tappet. Produkterne står ofte hos producenten i 2 måneder før vi modtager dem på vores lager, nogle gange endnu længere tid.
          </StyledParagraph>
          <StyledParagraph>
            For alle produkterne gælder det, at betegnelsen &quot;bedst før&quot; er synonym med &quot;ofte god efter&quot;.
            Vi tager forbehold for at holdbarheden kan ændre sig på de individuelle produkter fra denne side er skrevet.
          </StyledParagraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} md={6} alignCenter>
          <Heading2>Højeste holdbarhed på flasker fra tapning, glas</Heading2>
          <StyledParagraph>Kan leveres fra bryggeriet til os med helt ned til 2 måneders restløbetid</StyledParagraph>
          <StyledTable lines2>
            <Tr>
              <Th>Produkt</Th>
              <Th textRight>Tid (ca.)</Th>
            </Tr>
            <Tr>
              <Td>Coca Cola Zero 25cl glas:</Td>
              <Td textRight>6 måneder</Td>
            </Tr>
            <Tr>
              <Td>Faxe Kondi 0 kal, Pepsi Max 25cl glas:</Td>
              <Td textRight>6 måneder</Td>
            </Tr>
            <Tr>
              <Td>Frem Sodavand 25cl glas: </Td>
              <Td textRight>6 måneder</Td>
            </Tr>
            <Tr>
              <Td>Coca Cola, Tuborg Squash, Fanta Orange 25cl glas:</Td>
              <Td textRight>12 måneder</Td>
            </Tr>
            <Tr>
              <Td>Faxe Kondi, Pepsi, Nikoline 25cl glas:</Td>
              <Td textRight>12 måneder</Td>
            </Tr>
            <Tr>
              <Td>Søbogaard saft 25cl glas:</Td>
              <Td textRight>1 år 3 måneder</Td>
            </Tr>
            <Tr>
              <Td>Cocio glas: </Td>
              <Td textRight>1 år 9 måneder</Td>
            </Tr>
            <Tr>
              <Td>Acqua Panna 25cl + 100cl glas: </Td>
              <Td textRight>2 år</Td>
            </Tr>
          </StyledTable>
        </Col>
        <Col xs={12} md={6} textCenter alignCenter>
          <Div>
            <ScreenSizeDetector imageHeight={[[767, '200px'], [991, '250px'], [1199, '280px'], '300px']}>
              <Image name="produkter-oelvand.coca-cola-zero-25cl-1.png" margin="0 5px" />
              <Image name="produkter-oelvand.frem-hindbaer-25cl.png" margin="0 5px" />
              <Image name="produkter-oelvand.tuborg-squash-25cl.png" margin="0 5px" />
              <Image name="produkter-oelvand.6110-flaske.png" margin="0 5px" />
            </ScreenSizeDetector>
          </Div>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <ScreenSizeDetector direction={[[767, 'row'], 'row-reverse']}>
        <Row>
          <Col xs={12} md={6} alignCenter>
            <Heading2>Højeste holdbarhed på flasker fra tapning, plast</Heading2>
            <StyledParagraph>Når vi modtager varerne fra bryggeriet på vores lager, er der ofte kun 2 måneder tilbage på holdbarheden.</StyledParagraph>
            <StyledTable lines2>
              <Tr>
                <Th>Produkt</Th>
                <Th textRight>Tid (ca.)</Th>
              </Tr>
              <Tr>
                <Td>Faxe Kondi, Pepsi, Pepsi Max plast:</Td>
                <Td textRight>5 måneder</Td>
              </Tr>
              <Tr>
                <Td>Coca Cola, Coca Cola Zero plast:</Td>
                <Td textRight>6 måneder</Td>
              </Tr>
              <Tr>
                <Td>Aqua d&apos;or, Denice kildevand uden brus plast:</Td>
                <Td textRight>2 år</Td>
              </Tr>
            </StyledTable>
          </Col>
          <Col xs={12} md={6} textCenter alignCenter>
            <Div>
              <ScreenSizeDetector imageHeight={[[767, '200px'], [991, '250px'], [1199, '280px'], '300px']}>
                <Image name="produkter-oelvand.9042-flaske.png" margin="0 5px" />
                <Image name="produkter-oelvand.coca-cola-zero-2021-50cl.png" margin="0 5px" />
                <Image name="produkter-oelvand.tuborg-squash-50cl.png" margin="0 5px" />
                <Image name="produkter-oelvand.faxe-kondi-50cl-1.png" margin="0 5px" />
              </ScreenSizeDetector>
            </Div>
          </Col>
        </Row>
      </ScreenSizeDetector>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} md={6} alignCenter>
          <Heading2>Højeste holdbarhed på dåser fra tapning</Heading2>
          <StyledParagraph>Når vi modtager varerne fra bryggeriet på vores lager, er der ofte kun 2 måneder tilbage på holdbarheden.</StyledParagraph>
          <StyledTable lines2>
            <Tr>
              <Th>Produkt</Th>
              <Th textRight>Tid (ca.)</Th>
            </Tr>
            <Tr>
              <Td>Coca Cola Zero dåse:</Td>
              <Td textRight>6 måneder</Td>
            </Tr>
            <Tr>
              <Td>Coca Cola dåse:</Td>
              <Td textRight>12 måneder</Td>
            </Tr>
            <Tr>
              <Td>Cocio dåse:</Td>
              <Td textRight>1 år 9 måneder</Td>
            </Tr>
          </StyledTable>
        </Col>
        <Col xs={12} md={6} textCenter alignCenter>
          <Div>
            <ScreenSizeDetector imageHeight={[[767, '120px'], [991, '180px'], '200px']}>
              <Image name="produkter-oelvand.coca-cola-zero-2021-33cl-daase.png" margin="0 5px" />
              <Image name="produkter-oelvand.pepsi-max-daase-33cl.png" margin="0 5px" />
              <Image name="produkter-oelvand.faxe-kondi-daase-33cl-3.png" margin="0 5px" />
            </ScreenSizeDetector>
          </Div>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
